export default {
  appId: '604690853874499587',
  apiKey: 'fp4-HnAPF!3o)[GA2Bi*OEQdTXCOL7n]5X706PK6$G',
  environment: 'development'
}



// WEBPACK FOOTER //
// ./src/scillinfo.js